import { useSelector } from "react-redux";
import { getCrudPermissions, getGroupCrudPermissions } from "../selectors/getCrudPermissions";

export const usePermissions = () => useSelector(getCrudPermissions);
export const useGroupPermissions = () => useSelector(getGroupCrudPermissions);
